import * as React from 'react';
import { ISearchSuggestionItem } from 'PyzShopUi/scripts/search-suggestion/interfaces';
import { etrackerCCAttributes } from 'PyzShopUi/scripts/etracker/EtrackerCCAttributes';


interface IMostPopularListProps {
    suggestionItems: ISearchSuggestionItem[];
}

const MostPopularList: React.FunctionComponent<IMostPopularListProps> = props => {
    const { suggestionItems } = props;
    const dataTrackAttr = {
        "data-track-id": 'suggestSearchTerm'
    };

    const prepareUrl = (url: string, itemName: string): string => {
        const searchUrl = new URL(url, window.location.origin);
        etrackerCCAttributes.prepareClickCCAttributes(searchUrl, itemName);

        return searchUrl.toString();
    }

    const displaySuggests = suggestionItems.map((item: ISearchSuggestionItem, index: number) => (
        <li key={index} className='search-suggestions-item'>
            <a title={item.name} href={prepareUrl(item.url, item.name)}>
                <i className='icon icon-size-small icon-trend'/>
                <span {...dataTrackAttr}>{item.name}</span>
            </a>
        </li>
    ));

    return (
        <ul>
            {displaySuggests}
        </ul>
    );
};

export default MostPopularList;
